/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Anchor_ClearInputs */

const en_us2_body_assessment_anchor_clear = /** @type {(inputs: Body_Assessment_Anchor_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop using this reference`)
};

const pt_br2_body_assessment_anchor_clear = /** @type {(inputs: Body_Assessment_Anchor_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parar de usar esta referência`)
};

const es_419_body_assessment_anchor_clear = /** @type {(inputs: Body_Assessment_Anchor_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar de usar esta referencia`)
};

const pt_pt2_body_assessment_anchor_clear = /** @type {(inputs: Body_Assessment_Anchor_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixar de usar esta referência`)
};

const fr_fr2_body_assessment_anchor_clear = /** @type {(inputs: Body_Assessment_Anchor_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne plus utiliser cette référence`)
};

const de_de2_body_assessment_anchor_clear = /** @type {(inputs: Body_Assessment_Anchor_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenz nicht mehr nutzen`)
};

const it_it2_body_assessment_anchor_clear = /** @type {(inputs: Body_Assessment_Anchor_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smetti di usare questo riferimento`)
};

/**
* | output |
* | --- |
* | "Stop using this reference" |
*
* @param {Body_Assessment_Anchor_ClearInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_anchor_clear = /** @type {((inputs?: Body_Assessment_Anchor_ClearInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Anchor_ClearInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_anchor_clear(inputs)
	if (locale === "es-419") return es_419_body_assessment_anchor_clear(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_anchor_clear(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_anchor_clear(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_anchor_clear(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_anchor_clear(inputs)
	return en_us2_body_assessment_anchor_clear(inputs)
});
export { body_assessment_anchor_clear as "body-assessment.anchor_clear" }